import { render, staticRenderFns } from "./BucketZone.vue?vue&type=template&id=7930a31a&scoped=true&"
import script from "./BucketZone.vue?vue&type=script&lang=js&"
export * from "./BucketZone.vue?vue&type=script&lang=js&"
import style0 from "./BucketZone.vue?vue&type=style&index=0&id=7930a31a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7930a31a",
  null
  
)

export default component.exports